import { Screen } from '@rahtab/stack-navigator';
// import { withToman } from '@rahtab/system/lib/tools/string';
import { Card, CardContainer, Colors, getSpacing, ListEmpty, Text, TextView } from '@rahtab/ui';
import Button from '@rahtab/ui/dist/components/Button';
import React from 'react';
import { RefreshControl, ScrollView, StyleSheet, View } from 'react-native';
import ChevronLeftIcon from '@rahtab/ui/dist/icons/ChevronLeftIcon';
import BillingCard from './BillingCard';
import useBilling, { BillingInfo } from '../../hooks/‌Bill/useBilling';
import ListEmptyComponentIcon from '@rahtab/ui/dist/icons/ListEmptyIcons/BillingInfo';
import AlertIcon from '@rahtab/ui/dist/icons/AlertIcon';
import usePayment from 'hooks/‌Bill/usePayment';

const Billing = () => {
  const { data, called, loading, refetch } = useBilling();
  // const { loading: paymentLoading, payment } = usePayment();
  return (
    <Screen
      title="صورت‌حساب"
      loading={!called && loading}
      // transparentLoading={paymentLoading}
      data={data}
      renderControls={({ transactionCount }) => {
        return (
          <View style={styles.control}>
            {/* <TextView
              style={{ flex: 1 }}
              marginBottom={0}
              isSpaceBetween
              title="بدهی"
              value={withToman(currentDebt)}
              valueColor={debtExceeded ? 'secondary' : 'default'}
              borderColor={debtExceeded ? 'secondary' : 'default'}
            /> */}
            <Button
              color="primary"
              screenName="InvoiceList"
              params={{ transactionCount }}
              style={StyleSheet.flatten([styles.control, styles.billHistoryBtn])}>
              <Text variant="mediumBody" color="white" margin="none">
                سوابق پرداخت
              </Text>
              <ChevronLeftIcon />
            </Button>
          </View>
        );
      }}
      renderMain={({ items, from, to, total, debtExceeded, debtExceededMessage }: BillingInfo) => {
        return (
          <>
            {items.length > 0 ? (
              <ScrollView
                style={styles.scrollView}
                refreshControl={<RefreshControl onRefresh={refetch} refreshing={called && loading} />}>
                {debtExceeded && (
                  <Card style={styles.card}>
                    <CardContainer style={styles.alertCard}>
                      <AlertIcon fill={Colors.secondary} style={styles.alertIcon} />
                      <Text variant="cardTitle" color="secondary" margin="none">
                        {debtExceededMessage}
                      </Text>
                    </CardContainer>
                  </Card>
                )}
                <BillingCard
                  id={''}
                  from={from}
                  to={to}
                  items={items}
                  total={total}
                  cardAction={<Button color="secondary" text="پرداخت الکترونیکی صورت‌حساب" disabled={true} />}
                />
              </ScrollView>
            ) : (
              <ListEmpty text="صورت‌حسابی وجود ندارد." imageComponent={<ListEmptyComponentIcon />} />
            )}
          </>
        );
      }}
    />
  );
};

export default Billing;

const styles = StyleSheet.create({
  control: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  billHistoryBtn: {
    justifyContent: 'space-between',
    flex: 1.2,
    // marginLeft: getSpacing(),
    padding: getSpacing(),
  },
  scrollView: {
    padding: getSpacing(0.5),
  },
  card: {
    margin: getSpacing(0.5),
  },
  alertCard: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  alertIcon: {
    marginRight: getSpacing(),
  },
});
